import React, { ComponentType } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import withTheme from '@material-ui/core/styles/withTheme';
import BaseListSlick, { styles } from '../Shared/ListSlick';
import Card from './Card';
import { Props as BaseProps } from '../../core/Shared/ListSlick';
import { ThemePageCard } from '../pages/Top';
import { HOME_LIST_SLICK_AUTOPLAY_MS } from '../constants/homeListSlick';

type Props = {
  themePages: ThemePageCard[];
  /** When true, matches other home rows (e.g. active region). Default false. */
  autoplay?: boolean;
};

class ListSlick extends BaseListSlick {
  props: BaseProps & Props;

  settings = (theme) => ({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: this.props.autoplay ?? false,
    adaptiveHeight: true,
    autoplaySpeed: HOME_LIST_SLICK_AUTOPLAY_MS,
    infinite: false,
    responsive: [
      {
        breakpoint: theme.breakpoints.values.xl,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: theme.breakpoints.values.lg,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: {
          infinite: false,
          slidesToShow: 2.25,
          arrows: false,
        },
      },
    ],
  });

  slickItemsRenderer() {
    const { classes, themePages = [] } = this.props;
    return themePages.map((page) => (
      <Card
        key={`theme-page-slick-${page.id}`}
        className={classes.card}
        {...page}
      />
    ));
  }
}

export default withTheme(withStyles(styles)(ListSlick)) as ComponentType<Props>;
